import {
  AuthenticationRequiredError,
  BrowserAuthManager,
} from "@groundspark/browser-auth";
import type { AppConfig } from "./config";

export { AuthenticationRequiredError };

export class AuthManager extends BrowserAuthManager {
  public constructor(config: AppConfig) {
    super(config, "groundspark_admin_session_v2");
  }
}
